import {Alert, IconButton} from "@mui/material";
import {useFieldArray, useFormContext} from "react-hook-form";
import {BrandEditorItem} from "./BrandItemEditor";
import {useRecoilValue} from "recoil";
import {CurrentUserIsShop} from "../../../atoms/CurrentUser";
import {BrandItemStateEnum} from "../../../Queries";
import {FormInputText} from "../../shop/wholesale/form/FormInputText";
import {DateFormat} from "../../../utility/DateFormat";
import {FormInputCheckbox} from "../../shop/wholesale/form/FormInputCheckbox";
import {AddCircle, DeleteForeverRounded} from "@mui/icons-material";

export const BrandItemProblems = () => {
   const methods = useFormContext<BrandEditorItem>();
   const isBrandHouse = useRecoilValue(CurrentUserIsShop);
   const {control, watch} = methods;

   const {fields, append, remove} = useFieldArray({
      control,
      name: "problems",
   });
   const itemState = watch('itemState') as BrandItemStateEnum
   return <div>
      {fields.map((field, index) => {
         return <div key={"problem_" + index}>
            <FormInputText name={`problems[${index}].description`}
                           label={DateFormat.toPresent(field.createdAt || new Date())}
                           multiline
                           errorMessage={"Description is required"}
                           InputProps={{
                              endAdornment: <><FormInputCheckbox name={`problems[${index}].solved`}
                                                                 control={control}
                                                                 label={"Solved"}/>
                                 <IconButton onClick={() => {
                                    remove(index);
                                 }}><DeleteForeverRounded/></IconButton>
                              </>
                           }}
            />
         </div>
      })}
      {((itemState === BrandItemStateEnum.REVIEW || (isBrandHouse && itemState === BrandItemStateEnum.DRAFT)) && (fields.filter(f => !f.solved).length) > 0) &&
         <Alert variant={"filled"} style={{marginBottom: '10px'}} severity="error">Make sure all issues are resolved,
            then click "Solved"</Alert>
      }
      <IconButton onClick={() => append({
         description: '',
         solved: false,
         createdAt: new Date()
      })}>
         <AddCircle/>
      </IconButton>
   </div>
}